import { useCallback, useState } from 'react';

import { openDirectMessageByKey } from '../lib/directMessageNavigation';
import { logError } from '../lib/logger';

const useStartDirectMessage = (directMessageKey) => {
  const [isStartingDirectMessage, setIsStartingDirectMessage] = useState(false);

  const startDirectMessage = useCallback(async () => {
    if (!directMessageKey || isStartingDirectMessage) return;

    setIsStartingDirectMessage(true);
    try {
      await openDirectMessageByKey(directMessageKey);
    } catch (error) {
      logError('direct-messages', 'Failed to start direct message', error);
    } finally {
      setIsStartingDirectMessage(false);
    }
  }, [directMessageKey, isStartingDirectMessage]);

  return { isStartingDirectMessage, startDirectMessage };
};

export default useStartDirectMessage;
